const nhsNumberRe = /^(\d{3})(\d{3})(\d{4})$/;

export function nhsNumberFormatter(number?: string | null) {
    if (typeof number === 'string' && number.match(nhsNumberRe)) {
        return number.replace(nhsNumberRe, '$1 $2 $3');
    }

    return number;
}
